export default {
    receiver: {
        title: 'Ordini',
        subtitle: 'Gestisci i tuoi ordini inviati agli spedizionieri',
        newOrder: 'Nuovo Ordine',
        tableTitle: 'Ordini Inviati',
        tableDescription: 'Elenco di tutti gli ordini che hai inviato agli spedizionieri',
        headers: {
            orderId: 'ID Ordine',
            shipper: 'Spedizioniere',
            targetWeek: 'Settimana Target',
            status: 'Stato',
            createdAt: 'Creato il',
            actions: 'Azioni'
        }
    },
    sender: {
        title: 'Ordini',
        subtitle: 'Gestisci gli ordini ricevuti dai destinatari',
        tableTitle: 'Ordini Ricevuti',
        tableDescription: 'Elenco di tutti gli ordini ricevuti dai destinatari',
        accept: 'Accetta',
        reject: 'Rifiuta',
        modify: 'Modifica',
        headers: {
            orderId: 'ID Ordine',
            receiver: 'Destinatario',
            targetWeek: 'Settimana Target',
            status: 'Stato',
            createdAt: 'Creato il',
            actions: 'Azioni'
        }
    },
    list: {
        loading: 'Caricamento ordini...',
        noOrders: 'Nessun ordine trovato',
        searchPlaceholder: 'Cerca ordini...',
        filters: {
            allStatuses: 'Tutti gli stati'
        }
    },
    detail: {
        title: 'Dettaglio Ordine',
        subtitle: 'Visualizza e gestisci i dettagli dell\'ordine',
        loading: 'Caricamento dettagli ordine...',
        notFound: 'Ordine non trovato',
        backToList: 'Torna alla lista',
        back: 'Indietro',
        shipper: 'Spedizioniere',
        receiver: 'Destinatario',
        targetWeek: 'Settimana Target',
        createdAt: 'Creato il',
        respondedAt: 'Risposto il',
        notes: 'Note',
        rejectionReason: 'Motivo del Rifiuto',
        proposedChanges: 'Modifiche Proposte',
        modificationRequested: 'Richiesta di Modifica Inviata',
        modificationRequestedDescription: 'Hai inviato una richiesta di modifica per questo ordine. Il Receiver riceverà una notifica e potrà accettare o rifiutare le modifiche proposte.',
        acceptChanges: 'Accetta Modifiche',
        acceptChangesAndResend: 'Accetta Modifiche e Re-invia Ordine',
        rejectChanges: 'Rifiuta Modifiche',
        changesAcceptedMessage: 'Le modifiche sono state accettate e l\'ordine è stato reinviato allo Shipper.',
        packingList: {
            title: 'Packing List',
            requested: 'Packing List Richiesta',
            provided: 'Packing List Fornita',
            notSpecified: 'Non specificata',
            providePlaceholder: 'Inserisci la packing list fornita...',
            save: 'Salva Packing List'
        },
        contractualInfo: {
            title: 'Informazioni Contrattuali',
            contractNumber: 'Numero Contratto',
            contractNumberPlaceholder: 'Es. CONTRACT-2024-001',
            contractDate: 'Data Contratto',
            terms: 'Termini',
            termsPlaceholder: 'Inserisci i termini contrattuali...',
            notes: 'Note Contrattuali',
            notesPlaceholder: 'Note aggiuntive sul contratto...',
            save: 'Salva Informazioni'
        },
        orderItems: {
            title: 'Dettagli Ordine Cliente'
        },
        actions: {
            title: 'Azioni',
            accept: 'Accetta Ordine',
            reject: 'Rifiuta Ordine',
            modify: 'Proponi Modifiche'
        },
        rejectModal: {
            title: 'Rifiuta Ordine',
            reason: 'Motivo del Rifiuto',
            reasonPlaceholder: 'Inserisci il motivo del rifiuto...',
            submit: 'Conferma Rifiuto'
        },
        modifyModal: {
            title: 'Proponi Modifiche',
            changes: 'Modifiche Proposte',
            changesPlaceholder: 'Descrivi le modifiche che vuoi proporre...',
            submit: 'Invia Modifiche'
        }
    },
    form: {
        title: 'Nuovo Ordine',
        subtitle: 'Crea un nuovo ordine per un mittente',
        back: 'Indietro',
        cancel: 'Annulla',
        submit: 'Crea Ordine',
        saving: 'Salvataggio...',
        senderSection: 'Mittente',
        orderSection: 'Dettagli Ordine',
        sender: 'Mittente',
        senderPlaceholder: 'Seleziona un mittente',
        createNewSender: 'Crea Nuovo Mittente',
        newSenderName: 'Nome Mittente',
        newSenderNamePlaceholder: 'Es. TechCorp Solutions LLC',
        newSenderEmail: 'Email Mittente',
        newSenderEmailPlaceholder: 'contact@techcorp.com',
        newSenderCountry: 'Paese',
        newSenderCountryPlaceholder: 'Es. United States',
        createSender: 'Crea Mittente',
        shipperSection: 'Spedizioniere',
        shipper: 'Spedizioniere',
        shipperPlaceholder: 'Seleziona un spedizioniere',
        createNewShipper: 'Crea Nuovo Spedizioniere',
        newShipperName: 'Nome Spedizioniere',
        newShipperNamePlaceholder: 'Es. TechCorp Solutions LLC',
        newShipperEmail: 'Email Spedizioniere',
        newShipperEmailPlaceholder: 'contact@techcorp.com',
        newShipperCountry: 'Paese',
        newShipperCountryPlaceholder: 'Es. United States',
        createShipper: 'Crea Spedizioniere',
        targetWeek: 'Settimana Target',
        packingList: 'Packing List Richiesta',
        packingListPlaceholder: 'Descrivi in dettaglio la packing list richiesta...',
        notes: 'Note',
        notesPlaceholder: 'Note aggiuntive sull\'ordine...',
        errors: {
            allFieldsRequired: 'Tutti i campi obbligatori devono essere compilati',
            newSenderNotImplemented: 'La creazione di nuovi mittenti non è ancora implementata. Seleziona un mittente esistente.',
            newShipperNotImplemented: 'La creazione di nuovi spedizionieri non è ancora implementata. Seleziona un spedizioniere esistente.',
            generic: 'Si è verificato un errore durante la creazione dell\'ordine'
        }
    }
};

